module.exports = __webpack_public_path__ + "static/media/ic_copy.a0c2f19a.svg";